import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import i18n from 'i18next'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { MktButton, Icon } from '@cps'
import { map } from '@dt/fe-utils/dist/lodash'
import { virtualOrderMobx, memberMobx } from '@mobxStore'
import { useHistoryNew, getPlatform } from '@utils'
import './index.scss'

interface IProps extends IPage, RouteComponentProps {
}

const Result: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { orderId } = match.params as any
  const { getVirtualOrder } = virtualOrderMobx
  const { refreshMemeberBenefits } = memberMobx
  const [email, setEmail] = useState<string>('')
  const [type, setType] = useState<string>('')
  const [cardNum, setCardNum] = useState<number>(0)
  const closePage = () => {
    const { isWeixinMiniProgram } = getPlatform()
    if (isWeixinMiniProgram) {
      return history.replace('/my')
    }
    history.goBack()
  }
  useIonViewWillEnter(() => {
    refreshMemeberBenefits()
    setEmail('')
    setCardNum(0)
  })
  useEffect(() => {
    getVirtualOrder(orderId).then((res: any) => {
      if (res) {
        setEmail(res.extra.email || '')
        setType(res.extra.eatType)
        let num: number = 0
        map(res.orderDetail, (item: any) => {
          if (item.parentId === '0') {
            num += item.cnt
          }
        })
        setCardNum(num)
      }
    })
  }, [orderId])
  return (
    <IonPage
      className='giftcard-result-page'
    >
      <IonContent className='page-content'>
        <div className='success-panel'>
          <Icon className='icon' name='giftcard-success' />
          <div className='title'>
            {type === 'giftcard' ? <span>{i18n.t('mkt.giftCard.buySuccess', { cardNum: cardNum })}</span> : <span>{type === 'memberCardBuy' ? i18n.t('mkt.member.buySuccess') : i18n.t('mkt.giftCard.rechargeSuccess')}</span>}
          </div>
          {type === 'giftcard' && <div className='desc'>{i18n.t('mkt.giftCard.buySuccessDesc', { text: email || i18n.t('mkt.giftCard.myGiftCard') })}</div>}
        </div>
        <MktButton text={i18n.t('mkt.common.continue')} onClick={closePage} />
      </IonContent>
    </IonPage>
  )
}

export default observer(Result)
